<template>
  <div class="read-rank">
    <van-image
      class="top-image"
      width="100%"
      src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-09-14-14-472HWOj9aSS379TXmz.png"
    />
    <!-- 阅读之星榜 -->
    <div class="rank-item">
      <div class="rank-item-title">
        阅读之星榜
      </div>
      <div class="rank-item-desc">阅读文章数</div>
      <div class="read-list">
        <div class="read-item" v-for="(rowData, index) in readList" :key="rowData.rank">
          <div class="rank-item-user">
            <van-image
              class="rank-item-user-image"
              round
              width="24px"
              height="24px"
              :src="NumIconList[index]"
            />
            <van-image
              class="rank-item-user-image"
              @click="handlePersonal(rowData.userDTO.id)"
              round
              width="24px"
              height="24px"
              :src="rowData.userDTO.avatar"
            />
            <span>{{rowData.userDTO.erpName}}</span>
          </div>
          <div>{{rowData.score}}</div>
        </div>
        <div class="read-item" v-if="myRank && myRank.rank">
          <div class="rank-item-user">
            <div class="my-rank">{{myRank.rank}}</div>
            <van-image
              class="rank-item-user-image"
              @click="handlePersonal(myRank.userDTO.id)"
              round
              width="24px"
              height="24px"
              :src="myRank.userDTO.avatar"
            />
            <span>{{myRank.userDTO.erpName}}</span>
            <span class="tips" v-if="myRank.score > 99">您已进入抽奖池</span>
          </div>
          <div>{{myRank.score}}</div>
        </div>
      </div>
      
    </div>
    <div class="join" @click="() => goHome()">立即参与</div>
    <!-- 推荐之星榜 -->
    <div class="rank-item">
      <div class="rank-item-title">
        推荐之星榜
      </div>
      <div class="rank-item-desc">畅聊点赞数</div>
      <div class="rank-list">
        <div class="read-item" v-for="(rowData, index) in bbsList" :key="rowData.id">
          <van-image
            class="rank-item-user-image"
            round
            width="24px"
            height="24px"
            :src="NumIconList[index]"
          />
          <div class="bbs-content">
            <div class="rank-item-user">
              <van-image
                class="rank-item-user-image"
                @click="handlePersonal(rowData.userId)"
                round
                width="24px"
                height="24px"
                :src="rowData.userIconUrl"
              />
              <span>{{rowData.userName}}</span>
            </div>
            <div @click="() => goBbsDetail(rowData.id)" class="bbs-info">{{rowData.info}}</div>
          </div>
          <div>{{rowData.upNum}}</div>
        </div>
      </div>
      
    </div>
    <div class="join" @click="() => goTopic()">立即参与</div>
  </div>
</template>
<script>
import api from '@/api';
import num_1_icon from '@/assets/num_1@2x.png';
import num_2_icon from '@/assets/num_2@2x.png';
import num_3_icon from '@/assets/num_3@2x.png';
import num_4_icon from '@/assets/num_4@2x.png';
import num_5_icon from '@/assets/num_5@2x.png';
import num_6_icon from '@/assets/num_6@2x.png';
import num_7_icon from '@/assets/num_7@2x.png';
import num_8_icon from '@/assets/num_8@2x.png';
import num_9_icon from '@/assets/num_9@2x.png';
import num_10_icon from '@/assets/num_10@2x.png';


export default {
  data() {
    return {
      readList: [],
      myRank: [],
      bbsList: [],
      NumIconList : [
        num_1_icon,
        num_2_icon,
        num_3_icon,
        num_4_icon,
        num_5_icon,
        num_6_icon,
        num_7_icon,
        num_8_icon,
        num_9_icon,
        num_10_icon,
      ]
    };
  },
  mounted() {
    this.getReadRank();
    this.getTopicList();
    this.handleBack();
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'articleList' })
    },
    goTopic() {
      const query = {
                topic: '神灯阅读节，我来推好文'
            };
            this.$router.push({ name: 'release', query })
    },
    async getReadRank() {
      const { code, data } = await api.getReadRank();
      if (code === 200) {
        const { ranks, myRank } = data;
        this.readList = ranks || [];
        if (myRank?.rank > 10) {
          this.myRank= myRank || {};
        }
      }
      console.log(data)
      
    },
    async getTopicList() {
      const { code, data } = await api.getTopicList({
        topicId: 36,
        pageSize: 10,
        page: 1,
        real: 1,
        orderType: 66,
      });
      if (code === 200) {
        this.bbsList = data || [];
      }
    },
    handlePersonal(id) {
      if (id === -1) return;
      this.$router.push({ name: 'personal', query: { id } })
    },
    goBbsDetail(id) {
      this.$router.push({ name: 'bbsDetail', params: { id } })
    },
    handleBack() {
      const _this = this
      let options = {
        disabled: true,
        callback: function() {
          if (window.history.length > 1) {
            _this.$router.go(-1)
          } else {
            _this.$router.replace({ name: 'articleList' })
          }
        }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
  },
}
</script>
<style lang="less" scoped>
.read-rank {
  background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-09-14-14-46QYOVxAjlaU6tzXQ.png');
  background-size: cover;
  height: 100vh;
  overflow-y: auto;
  padding: 4px 12px 16px 12px;
  text-align: left;
}
.rank-item {
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
  // margin: 16px 0;
}
.rank-item-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.rank-item-desc {
  font-size: 12px;
  text-align: right;
  color: #77798e;
  margin: 2px 0;
}
.read-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  margin: 4px 0;
  color: #77798e;
  font-size: 14px;
  font-weight: bold;
}
.rank-item-user {
  display: flex;
  align-items: center;
  font-weight: normal;
  color: #232930;
}
.rank-item-user-image {
  margin-right: 8px;
}
.my-rank {
  margin-right: 8px;
  border-radius: 4px;
  color: #fff;
  background: #2695F1;
  padding: 0 4px;
}
.tips {
  font-size: 12px;
  color: red;
  margin-left: 8px;
}
.bbs-content {
  flex: 1;
  overflow: hidden;
}
.bbs-info {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 16px;
}
.join {
  margin: 8px 0 24px;
  text-align: center;
  color: #2695F1;
  text-decoration: underline;
}
</style>